import { CAT_IDS, CATS } from "../data/cats";
import type { GameState } from "../types";

export function createDefaultState(now = Date.now()): GameState {
  return {
    schemaVersion: 2,
    coins: 120,
    level: 1,
    exp: 0,
    player: {
      created: false,
      displayName: "ชาวสวน",
      bodyType: "soft",
      hairStyle: "bob",
      hairColor: "cocoa",
      outfit: "lavender",
      outfitColor: "lavender",
      cellX: 6,
      cellY: 5,
      direction: "right",
    },
    inventory: {
      seeds: { carrot: 5, tomato: 3, cabbage: 2 },
      produce: { carrot: 0, tomato: 0, cabbage: 0 },
      catFood: 0,
      decorations: { fence: 4, tree: 1, flowers: 3, catHouse: 1 },
    },
    plots: [
      { id: "plot-1", cellX: 3, cellY: 3, cropId: null, plantedAt: null, wateredAt: null, readyAt: null },
      { id: "plot-2", cellX: 4, cellY: 3, cropId: null, plantedAt: null, wateredAt: null, readyAt: null },
      { id: "plot-3", cellX: 5, cellY: 3, cropId: null, plantedAt: null, wateredAt: null, readyAt: null },
      { id: "plot-4", cellX: 3, cellY: 4, cropId: null, plantedAt: null, wateredAt: null, readyAt: null },
      { id: "plot-5", cellX: 4, cellY: 4, cropId: null, plantedAt: null, wateredAt: null, readyAt: null },
      { id: "plot-6", cellX: 5, cellY: 4, cropId: null, plantedAt: null, wateredAt: null, readyAt: null },
    ],
    cats: CAT_IDS.map((id) => {
      const cat = CATS[id];
      return {
        id,
        name: cat.name,
        breed: cat.breed,
        furColor: cat.furColor,
        color: cat.tint,
        accent: cat.baseSprite === "mali" ? 0x7b5949 : cat.baseSprite === "khram" ? 0x62687d : 0xfff4dc,
        appearance: cat.appearance,
        personality: cat.personality,
        rarity: cat.rarity,
        owned: false,
        hunger: 86,
        happiness: 72,
        behavior: "idle" as const,
        cellX: cat.home.cellX,
        cellY: cat.home.cellY,
        location: "farm" as const,
        lastCareAt: now,
      };
    }),
    decorations: [
      { id: "decor-start-flowers", type: "flowers", cellX: 2, cellY: 5, rotation: 0 },
      { id: "decor-start-fence", type: "fence", cellX: 6, cellY: 2, rotation: 0 },
    ],
    ownedFurniture: [],
    lastUpdatedAt: now,
  };
}
